import YoutubeVideoVisualPreviewContent from '@cohort/components-xps/components/contents/apps/youtube/video/VisualPreviewContent';
import type {VisualPreviewProps} from '@cohort/merchants/apps';
import type {YoutubeVideoMediaStruct} from '@cohort/shared/apps/youtube/medias/video';

const YoutubeVideoVisualPreview: React.FC<VisualPreviewProps<YoutubeVideoMediaStruct>> = ({
  config,
  title,
  className,
}) => {
  return (
    <YoutubeVideoVisualPreviewContent
      videoId={config.videoId}
      title={title}
      className={className}
    />
  );
};

export default YoutubeVideoVisualPreview;
